import { formatNOK } from "@/lib/format";
import { STAGE_LABELS } from "@/lib/opportunity-calc";
import { PIPE_STAGES, type PipeStage } from "@/lib/pipe-board-calc";
import type { WeightedPipelineResult } from "@/lib/offer-pipeline-calc";

interface PipeSummaryCardsProps {
  weighted: WeightedPipelineResult;
  counts: Record<PipeStage, number>;
}

/** Vektet verdi i Tilbud (blått aksentkort) og antall per kolonne. */
export default function PipeSummaryCards({ weighted, counts }: PipeSummaryCardsProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <div className="kpi-card accent">
        <div className="label">Vektet verdi i Tilbud</div>
        <div className="value">{formatNOK(weighted.weightedKr)}</div>
        <div className="delta">
          {formatNOK(weighted.rawKr)} totalt
          {weighted.uncategorizedCount > 0 && ` · ${weighted.uncategorizedCount} uten sannsynlighet`}
        </div>
      </div>
      {PIPE_STAGES.map((stage) => (
        <div key={stage} className="kpi-card">
          <div className="label">{STAGE_LABELS[stage]}</div>
          <div className="value">{counts[stage]}</div>
        </div>
      ))}
    </div>
  );
}
